import { FC } from "react";
import { parsePhone } from "src/framework/commons/masks";
import { ChangeValue, CustomTextField } from "../InputParameters";
import { InputText, InputTextParameters } from "../InputText";

export interface InputPhoneProperties extends InputTextParameters, CustomTextField { }

const InputPhone: FC<InputPhoneProperties> = ({
    fullWidth = true,
    onChangeValue,
    value,
    ...props
}) => {

    const parseValue = (): string | undefined => {
        if (value) {
            if ((value.replaceAll(/\d/g, "").length === 0)) {
                return parsePhone(value)
            }
            return value
        }

        return ""
    }

    return <InputText
        {...props}
        mask="phone"
        fullWidth={fullWidth}

        value={parseValue()}
        onChange={(e: any) => {
            if (props.onChange) {
                props.onChange(e)
            }

            if (onChangeValue) {
                const val = e.target.value;

                const newValue: ChangeValue = {
                    name: props?.name ? props.name : null,
                    value: e?.nativeEvent?.inputType === 'deleteContentBackward' ? val : parsePhone(val),
                    numberValue: Number(val.replace(/\D/g, ""))
                }

                onChangeValue(newValue)
            }
        }}
    />
}

export { InputPhone }